var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Image_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.658 96.497H9.938l-2.97-27.58 10.4 11.52.66-20.66 7.53 19.62 6.54-23.69 12.56 40.79Z",
    fill: "#28BF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.561 96.5 1.949-3.968A18.578 18.578 0 0 1 90 81.962a16.915 16.915 0 0 1 10.688 3.782L113.943 96.5H71.561Z",
    fill: "#192C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.558 89.997-1.194-.587.864-.413-5.21-16-9.958-7.39 4.418-9.61-5.21-16-7.27-3-11.4 3-5.77 16 2.746 11.692-8.886 5.308-6.13 17h-6.01l-.1 6h65l.1-6h-5.99Z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 96v1H3v-1h114Zm-33.772-7 .33 1H56v-1h27.228Z",
    fill: "#192C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.263 40h-18.67l6.13-17h7l5.54 17Zm5.215 16 5.54 17h-41.33l6.14-17h29.65Z",
    fill: "#116DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgImage;